import { Link } from 'react-router-dom';
import cc from 'classcat';
import { useTranslation } from '../../../hooks/useTranslation';
import { useFeatureFlag } from '../../../hooks/featureFlags/useFeatureFlags';
import { AppConfig } from '../../../config/AppConfig';

interface PremiumTooltipProps {
    className?: string;
    position?: 'top' | 'bottom' | 'left' | 'right';
    showOnHover?: boolean;
}

export const PremiumTooltip = ({ className, position = 'bottom', showOnHover = false }: PremiumTooltipProps) => {
    const { t } = useTranslation();
    const billingEnabled = useFeatureFlag('BILLING');
    const isDevelopment = AppConfig.isDevelopment;

    // Don't show tooltip if billing feature is disabled
    // (always show in development for testing, or when billing is enabled)
    if (!isDevelopment && !billingEnabled) {
        return null;
    }

    const message = t('billing.premiumTooltip');
    const [before, after] = message.split('{{premiumLink}}');
    const premiumText = t('billing.premium');

    return (
        <div className={cc(['premium-tooltip', `premium-tooltip--${position}`, { 'premium-tooltip--hover': showOnHover }, className])}>
            <div className={cc(['premium-tooltip__content', 'paragraph-5'])}>
                {before}
                <Link to="/subscription" className={cc(['premium-tooltip__link', 'paragraph-5'])}>
                    {premiumText}
                </Link>
                {after}
            </div>
            <div className="premium-tooltip__arrow"></div>
        </div>
    );
};
